import { useState } from 'react';
import usePostRequest from '../../hooks/usePostRequest';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';

const AddToRole = () => {

    const [data, setData] = useState({
        email: "",
        role: "administrator"
    });
    const { post } = usePostRequest("/api/admin/add-to-role", data);

    const handleSubmit = async (event) => {
        event.preventDefault();
        let response = await post();
        if (!response.isValid) {
            toast.error("Error", {
                position: "top-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                theme: "colored",
            });
            return;
        }

        toast.info("Saved", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "colored",
        });
    }

    const handleChange = (event) => {
        setData({ ...data, email: event.target.value });
    }

    return (
        <>
            <h3 className='mt-4'>Add user to admin role</h3>
            <Form inline="true" onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                    <Form.Label htmlFor="userEmailTextInput">User Email</Form.Label>
                    <Form.Control id="userEmailTextInput" placeholder="Enter user's email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" required onChange={handleChange} />
                </Form.Group>
                <Button type="submit">Add to administrator role</Button>
            </Form>
        </>
    );
};

export default AddToRole;